import React from 'react';
import styles from './AdDetailsMobileLoader.scss';

const AdDetailsMobileLoader = () => (
  <div className={styles.skeletonLoader}>
    <div className={styles.breadcrumb}></div>
    <div className={styles.imageWrapper}></div>
    <div className={styles.heading}></div>
    <div className={styles.adInfo}></div>
    <div className={styles.price}></div> 
    <div className={styles.location}></div>
  </div>
);

export default AdDetailsMobileLoader;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/AdDetailsMobileLoader/index.tsx